import { handleApi } from "..";
import {
  TRAINING_LIST,
  TRAINING_LIST_DETAILS,
  MANUAL_TRAINING,
} from "../../constants/api_constants";

export const allTrainingList = async () => {
  return handleApi("get", TRAINING_LIST);
};

export const trainingDetails = async (id) => {
  return handleApi("get", `${TRAINING_LIST_DETAILS}/${id}`);
};

export const manualTrainingPayment = async (values) => {
  const { productId, id, notes } = values;
  return handleApi("put", `${MANUAL_TRAINING}/${productId}`, { id, notes });
};
